import React from "react";
import "./Home.css";
import img from "../images/gyctc-logo.png";
import TypedComponent from "./TypedComponent.js";
import Courses from "./Courses";
import Instructor from "./Instructor";
import ContactUs from "./ContactUs";
import Notice from "./Notice";
import CustomeAlert from "./CustomAlert";
import ImageCarousel from "./ImageCarousel";

const Body = () => {
  return (
    <>
      <div classname="body">
        {/* intro */}
        <section className="home" id="home">
          <div className="home-content">
            <div className="banner">
              <p>Welcome to</p>
              <h1>GYCTC</h1>
              <h4>{<TypedComponent />}</h4>
              <h3>
                Enhance your productivity and efficiency through our practical
                computer training programs. From office applications to advanced
                software, we have the expertise you need.
              </h3>
            </div>
            <div className="right-banner">
              <img src={img} alt="Logo" />
            </div>
          </div>
        </section>
        {/* NOTICE */}
        <section id="notice">
          <Notice />
        </section>
        {/* our courses */}
        <section id="our-courses">
          <Courses />
        </section>
        {/* our instructor */}
        <section id="instructor">
          <Instructor />
        </section>
        {/* Contact us */}
        <section id="contactus">
          <ContactUs />
        </section>
        {/* OTHERS */}
        <section id="alert">
          <CustomeAlert />
        </section>
      </div>
    </>
  );
};

export default Body;
